<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <WalletCard :class="b()" title="Заявки" tab="application">
    <div v-if="displayedHistory.length" :class="b('table')">
      <div :class="b('rows')">
        <WalletApplicationsRow
          :class="b('row')"
          v-for="(row, rowIndex) in displayedHistory"
          :key="rowIndex"
          :row="row"
        />
      </div>
    </div>

    <div v-else :class="b('empty')">
      <span :class="b('empty-icon')">⇄</span>
      <h5 :class="b('empty-title')">{{ $t("Пока нет заявок") }}</h5>
      <p :class="b('empty-text')">
        {{ $t("Здесь появятся ваши заявки на обмен") }}
      </p>
      <router-link :class="b('empty-cta')" :to="{ name: 'application' }">
        {{ $t("Обменять") }}
      </router-link>
    </div>
  </WalletCard>
</template>
